/*
 * Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { prebuiltIntegrationsUrl } from 'config';

/**
 * Where the prebuilt integration catalogue is published when a deployment does
 * not name one of its own.
 */
export const DEFAULT_PREBUILT_INTEGRATIONS_URL =
  'https://raw.githubusercontent.com/wso2/integration-samples/main/.metadata/prebuilt-integrations.json';

/**
 * The catalogue both the signed in product and the login landing page read.
 *
 * It lives here rather than in `hooks/prebuiltIntegrations` because the login
 * page is outside the query client and must not pull that module — and the two
 * surfaces showing different catalogues would mean a flow picked before signing
 * up is missing from the page it hands over to.
 */
export const getPrebuiltIntegrationsUrl = (): string =>
  prebuiltIntegrationsUrl ?? DEFAULT_PREBUILT_INTEGRATIONS_URL;
